import { render, staticRenderFns } from "./failing.vue?vue&type=template&id=af2f1c70&scoped=true&class=transaction&"
import script from "./failing.vue?vue&type=script&lang=js&"
export * from "./failing.vue?vue&type=script&lang=js&"
import style0 from "./failing.vue?vue&type=style&index=0&id=af2f1c70&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2f1c70",
  null
  
)

export default component.exports